export const recommenderCollection = {
  "musicChannels": [
    {
      "musicChannelId": 165,
      "musicCollections": [{"id": 8620}, {"id": 8220}]
    }
  ]};
